import { createContext, useContext } from "react";

export const ReactHookFormDebugEnabledContext = createContext<boolean>(false);

export const useReactHookFormDebugEnabled = () =>
  useContext(ReactHookFormDebugEnabledContext);
